module.exports = __webpack_public_path__ + "assets/images/scrolly-network/tablet.svg?v=a0a51525";